import { createTheme, PaletteMode, responsiveFontSizes } from '@mui/material';
import { red, grey, orange, amber, green } from '@mui/material/colors';

declare module '@mui/material/styles' {
  interface SimplePaletteColorOptions {
    darker?: string;
  }
}

// A custom defaultTheme for the web app
let defaultTheme = createTheme({
  palette: {
    primary: {
      main: grey[300],
      darker: grey[900],
    },
    secondary: {
      main: orange[500],
      darker: orange[900],
    },
    error: {
      main: red[900],
    },
    warning: {
      main: orange[500],
    },
    info: {
      main: red[100],
    },
    success: {
      main: green[600],
    },
  },
});

export const getDesignTokens = (mode: PaletteMode) => ({
  palette: {
    mode,
    ...(mode === 'light'
      ? {
          // palette values for light mode
          primary: amber,
          divider: amber[200],
          text: {
            primary: grey[900],
            secondary: grey[800],
          },
        }
      : {
          // palette values for dark mode
          primary: grey,
          divider: grey[100],
          background: {
            default: grey[800],
            paper: grey[800],
          },
          text: {
            primary: '#fff',
            secondary: grey[500],
          },
        }),
  },
});

defaultTheme = responsiveFontSizes(defaultTheme);

export default defaultTheme;
